// extracted by mini-css-extract-plugin
module.exports = {"app":"app_app__1ZWe8","appLayout":"app_appLayout__3GhEC"};